// extracted by mini-css-extract-plugin
module.exports = {"container":"_24L1ZLVCcgjH47Nq2-Ra0s"};